import loadSpecificCombatantHeadlineMarkers from "./loadSpecificCombatantHeadlineMarkers";
import store from "../store/index";
//---------------------------------
// load combatant headline markers
//---------------------------------
export default function loadCombatantHeadlineMarkers() {
  console.log("------------------------")
  console.log("IN loadCombatantHeadlineMarkers")
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  //----------------------
  // loop thru combatants
  //----------------------
  for (let i = 0; i < combatants.length; i++) {
    // console.log("call markers i = " + i + " name = " + combatants[i].name)
    //------------------------------------------
    // load specific combatant headline markers
    //------------------------------------------
    loadSpecificCombatantHeadlineMarkers(i);
  }
}
